export const KORK_MOODS = {
  happy: 'happy',
  surprised: 'surprised',
  cheeky: 'cheeky',
  proud: 'proud',
  hint: 'hint',
  worried: 'worried',
  wow: 'wow',
  angry: 'angry',
};

export const KORK_MOTIONS = {
  idle: 'idle',
  bob: 'bob',
  pop: 'pop',
  slide: 'slide',
  wave: 'wave',
  celebrate: 'celebrate',
};

export const KORK_DESIGN_TOKENS = {
  name: "Kaept'n Kork",
  role: 'frecher Pfandpirat-Kumpel',
  silhouette: 'grosser Piratenhut, runder Kopf, Ringelschwanz, kleine Jacke',
  defaultMood: KORK_MOODS.happy,
  defaultMotion: KORK_MOTIONS.bob,
};

const XP_LINES = {
  add_pfand: [
    'Aye! Sauberer Fund, Pirat.',
    'Das klimpert in der Crew-Kasse.',
    'Kork riecht Beute. Gute Beute.',
  ],
  mark_pfandspende: [
    'Captain Kork hat den Fund gesichtet.',
    'Sauber markiert, die Karte wird besser.',
    'Ahoi, das hilft der Crew.',
  ],
  pickup_pfandspende: [
    'Pfandspende abgeholt. Sauberer Kurs.',
    'Das Pfand ist geborgen.',
    'Stark, du hast die Meldung abgeschlossen.',
  ],
  pfandspende_confirmed: [
    'Gute Nachricht: deine Pfandmeldung hat geholfen.',
    'Danke, du hast Pfand sichtbar gemacht.',
    'Aus Hinweis wurde Wirkung.',
  ],
  barcode_scan: [
    'Schneller Scan, starker Fang.',
    'Zack, die Flasche ist kartiert.',
  ],
  freitext: [
    'Handarbeit zaehlt doppelt im Hafen.',
    'Nicht jeder Schatz hat einen Barcode.',
  ],
  complete_daily: [
    'Tagesziel geentert. Sehr stark.',
    'Die Crew hebt den Hut vor dir.',
  ],
  expedition_scan: [
    'Da draussen glitzert noch mehr.',
    'Expedition gelungen. Kork nickt zufrieden.',
  ],
  expedition_pfand_bonus: [
    'Pfand-Beifang! Genau mein Geschmack.',
    'Hehe, das lag da nicht zufaellig.',
  ],
  expedition_map_complete: [
    'Die Karte ist komplett. Jetzt wird es ernst.',
    'Alle Zeichen stehen auf Schatz.',
  ],
  redeem_pfand: [
    'Beute eingelost. Die Kasse singt.',
    'Aus Fund wird Gold. So muss das.',
  ],
  loot_find: [
    'Seltener Fund voraus.',
    'Kork hat da was funkeln sehen.',
  ],
  drink_submission_approved: [
    'Neues Wissen fuer die Crew.',
    'Guter Hinweis, Pirat.',
  ],
  remove_entry: [
    'Eintrag ueber Bord. Kurs korrigiert.',
    'Alles klar, Logbuch bereinigt.',
  ],
  generic_gain: [
    'Die Crew wird staerker.',
    'Nicht schlecht, Pirat.',
    'Kleine Beute, grosser Kurs.',
  ],
  generic_loss: [
    'Kurz den Kurs geprueft. Weiter gehts.',
    'Kein Drama, Pirat. Segel neu setzen.',
  ],
};

const MOMENT_LINES = {
  map_completed: 'Kork spuert: Das ist ein grosser Moment.',
  map_fragment_found: 'Ein Stueck Karte! Der Nebel weicht.',
  rare_loot_found: 'Das ist nicht irgendein Fund.',
  epic_loot_found: 'Aye, jetzt wird der Hafen hell.',
  pfand_beifang_found: 'Pfand-Beifang eingesackt.',
  level_up: 'Neuer Rang, neue Legende.',
  achievement: 'Die Crew wird davon hoeren.',
  default: 'Kork bleibt an deiner Seite.',
};

function pickStable(list, seed) {
  if (!Array.isArray(list) || list.length === 0) return '';
  const source = String(seed || list[0]);
  let hash = 0;
  for (let index = 0; index < source.length; index += 1) {
    hash = (hash * 31 + source.charCodeAt(index)) >>> 0;
  }
  return list[hash % list.length];
}

export function getKorkXpMood(change) {
  const awarded = Number(change?.awarded || 0);
  const event = String(change?.event || '');

  if (awarded < 0) return KORK_MOODS.angry;
  if (event === 'mark_pfandspende') return change?.amount_group === 'giveaway' ? KORK_MOODS.hint : KORK_MOODS.happy;
  if (event === 'pickup_pfandspende' || event === 'pfandspende_confirmed') return KORK_MOODS.proud;
  if (event === 'complete_daily' || event === 'expedition_map_complete') return KORK_MOODS.wow;
  if (event.includes('expedition') || event.includes('loot')) return KORK_MOODS.hint;
  if (awarded >= 50) return KORK_MOODS.wow;
  return KORK_MOODS.happy;
}

export function getKorkXpMotion(change) {
  const awarded = Number(change?.awarded || 0);
  if (awarded < 0) return KORK_MOTIONS.idle;
  if (awarded >= 50) return KORK_MOTIONS.celebrate;
  return KORK_MOTIONS.wave;
}

export function getKorkXpVariant(change) {
  const event = String(change?.event || '');
  const awarded = Number(change?.awarded || 0);

  if (awarded < 0) return 'angry';
  if (event === 'mark_pfandspende') return change?.amount_group === 'giveaway' ? 'tip' : 'pfandRight';
  if (event === 'pickup_pfandspende' || event === 'pfandspende_confirmed') return 'pfandRight';
  if (event === 'complete_daily') return 'wow';
  if (event.includes('loot')) return 'chest';
  if (event.includes('map') || event.includes('fragment') || event.includes('expedition')) return 'map';
  if (event.includes('tip') || event.includes('tutorial') || event === 'drink_submission_approved') return 'tip';
  if (event.includes('magnet') || event === 'barcode_scan') return 'magnet';
  if (event === 'redeem_pfand' || event.includes('coin')) return 'pfandRight';
  if (awarded >= 50) return 'wow';
  return pickStable(['pfandLeft', 'pfandRight'], `${event}:${change?.id || change?.xp || awarded}`);
}

export function getKorkXpLine(change) {
  const event = String(change?.event || '');
  const awarded = Number(change?.awarded || 0);
  const key = XP_LINES[event] ? event : awarded < 0 ? 'generic_loss' : 'generic_gain';
  return pickStable(XP_LINES[key], `${event}:${awarded}:${change?.id || change?.xp || ''}`);
}

export function getKorkMomentLine(moment) {
  const type = String(moment?.type || '');
  return MOMENT_LINES[type] || MOMENT_LINES.default;
}

export function getKorkMomentMood(moment) {
  const rarity = String(moment?.rarity || '');
  const type = String(moment?.type || '');
  if (rarity === 'legendary' || type === 'level_up' || type === 'map_completed') return KORK_MOODS.wow;
  if (type.includes('loot') || type.includes('fragment')) return KORK_MOODS.surprised;
  return KORK_MOODS.happy;
}

export function getKorkMomentVariant(moment) {
  const rarity = String(moment?.rarity || '');
  const type = String(moment?.type || '');

  if (type === 'level_up' || type === 'achievement') return 'wow';
  if (type === 'map_completed' || type.includes('fragment')) return 'map';
  if (type.includes('loot')) return 'chest';
  if (type === 'pfand_beifang_found') return 'pfandRight';
  if (rarity === 'legendary' || rarity === 'epic') return 'wow';
  if (rarity === 'rare') return 'surprised';
  return 'happy';
}
